import React, {  useRef, useState } from "react";
import { Modal } from "antd";
import { Button, Form, Input, notification } from "antd";
import "cropperjs/dist/cropper.css";
import API from "../../../config/API";
import { POST } from "../../../utils/apiCalls";
const PurityAddModal = (props: any) => {
  const [form] = Form.useForm();
  const [Notifications, contextHolder] = notification.useNotification();
  const [isLoading, setIsLoading] = useState(false);

  const formSubmitHandler = async (values: any) => {
    const url = API.ADD_PURITY;
    try {
      setIsLoading(true);
      const response: any = await POST(url, values);
      if (response?.status) {
        Notifications["success"]({
          message: "Purity Added successfully",
        });
        props?.close();
        form.resetFields();
        props?.refresh();
      } else {
        Notifications["error"]({
          message: response?.message,
        });
      }
    } catch (err: any) {
      Notifications["error"]({
        message: `Failed to Add Purity.."}`,
        description: err.message,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      title={`Add Purity`}
      open={props?.open}
      okText="Add"
      centered
      width={500}
      onOk={() => form.submit()}
      confirmLoading={isLoading}
      onCancel={() => {
        props?.close();
        form.resetFields();
      }}
    >
      {contextHolder}
      <Form form={form} layout="vertical" onFinish={formSubmitHandler}>
        <Form.Item
          label="MetalType"
          name={"metalType"}
          rules={[
            {
              required: true,
              message: "Please Enter MetalType",
            },
          ]}
        >
          <Input placeholder="MetalType" />
        </Form.Item>

        <Form.Item
          label="Purity"
          name={"purity"}
          rules={[
            {
              required: true,
              message: "Please Enter Purity",
            },
          ]}
        >
          <Input placeholder="Purity" type="number" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default PurityAddModal;
